/**
 * Helpers d'authentification côté front : hook React Query pour récupérer
 * l'utilisateur courant depuis /api/auth/me. Renvoie null si non authentifié.
 */
import { useQuery } from '@tanstack/react-query';
import type { SessionUser } from '@lecomptoir/shared';
import { apiFetch, ApiClientError } from './api';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async (): Promise<SessionUser | null> => {
      try {
        const data = await apiFetch<{ user: SessionUser }>('/auth/me');
        return data.user;
      } catch (err) {
        if (err instanceof ApiClientError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}
